import React, { FC } from "react";
import Badge from "../../shared/Badge/Badge";
import useGetBasketItems from "../../../booking/hooks/useGetBasketItems";

interface BasketBadgeProps {
    basketId: string;
}

const BasketBadge: FC<BasketBadgeProps> = (
    basketId
) => {
    const basketItemsQuery = useGetBasketItems(basketId.basketId);
    const {data: basketItems} = basketItemsQuery;

    return (
        <>
        {basketItems && (
            <Badge name={basketItems.length} color="green" className="ml-2"/>
        )}
        </>
    );
};

export default BasketBadge;
